import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { track } from "../../services/analytics";

// Image imports
import heroBg from "../../images/bg/hero_bg.png";
import heroIcon from "../../images/icon/animated-gif02.gif";
import featureIcon1 from "../../images/icon/feature-icon01.svg";
import featureIcon2 from "../../images/icon/feature-icon02.svg";
import featureIcon3 from "../../images/icon/feature-icon03.svg";

const HERO_FEATURES = [
  {
    icon: featureIcon1,
    titleKey: "hero.feature1Title",
    descKey: "hero.feature1Desc",
    delay: "700ms",
  },
  {
    icon: featureIcon2,
    titleKey: "hero.feature2Title",
    descKey: "hero.feature2Desc",
    delay: "800ms",
  },
  {
    icon: featureIcon3,
    titleKey: "hero.feature3Title",
    descKey: "hero.feature3Desc",
    delay: "900ms",
  },
];

const heroFeatureStyles = `
  .hero-feature-uniform {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .hero-feature-uniform .xb-item--inner {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .hero-feature-uniform .xb-item--holder {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .hero-feature-uniform .xb-item--title {
    min-height: 58px;
    display: flex;
    align-items: flex-start;
  }
  .hero-feature-uniform .xb-item--content {
    flex: 1;
    margin-bottom: 0;
    line-height: 1.6;
  }
`;

const HeroSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section
      className="hero hero-style pos-rel bg_img"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      <style>{heroFeatureStyles}</style>
      <div className="container">
        <div className="row">
          {/* ---------- Left Content ---------- */}
          <div className="col-lg-9 col-md-9">
            <div className="hero-content">
              {/* The homepage's main heading — it was an <h2>, leaving the page with
                  no <h1> at all once the footer wordmark was demoted. Styling is
                  unchanged: the global h1-h6 rule and .title cover both tags. */}
              <h1 className="title scale-animation wow">
                {t('hero.title')}
              </h1>
              <p className="sub-title scale-animation wow">
                {t('hero.subtitle')}
              </p>
              <div className="hero-btn scale-animation wow">
                <Link
                  className="thm-btn agency-btn"
                  to="/signup"
                  onClick={() => track("cta_click", { cta_id: "hero_cta" })}
                >
                  <span className="text">{t('hero.cta')}</span>
                  <span className="arrow">
                    <span className="arrow-icon">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="5.06592"
                          y="19.9785"
                          width="20.5712"
                          height="2.61221"
                          transform="rotate(-40.2798 5.06592 19.9785)"
                          fill="white"
                        />
                        <rect
                          x="7.97095"
                          y="7.24463"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 7.97095 7.24463)"
                          fill="white"
                        />
                        <rect
                          x="11.6523"
                          y="7.54834"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 11.6523 7.54834)"
                          fill="white"
                        />
                        <rect
                          x="15.334"
                          y="7.85205"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 15.334 7.85205)"
                          fill="white"
                        />
                        <rect
                          x="18.7119"
                          y="11.8374"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.7119 11.8374)"
                          fill="white"
                        />
                        <rect
                          x="18.4084"
                          y="15.52"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.4084 15.52)"
                          fill="white"
                        />
                        <rect
                          x="18.104"
                          y="19.2012"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.104 19.2012)"
                          fill="white"
                        />
                      </svg>
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="5.06592"
                          y="19.9785"
                          width="20.5712"
                          height="2.61221"
                          transform="rotate(-40.2798 5.06592 19.9785)"
                          fill="white"
                        />
                        <rect
                          x="7.97095"
                          y="7.24463"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 7.97095 7.24463)"
                          fill="white"
                        />
                        <rect
                          x="11.6523"
                          y="7.54834"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 11.6523 7.54834)"
                          fill="white"
                        />
                        <rect
                          x="15.334"
                          y="7.85205"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 15.334 7.85205)"
                          fill="white"
                        />
                        <rect
                          x="18.7119"
                          y="11.8374"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.7119 11.8374)"
                          fill="white"
                        />
                        <rect
                          x="18.4084"
                          y="15.52"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.4084 15.52)"
                          fill="white"
                        />
                        <rect
                          x="18.104"
                          y="19.2012"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.104 19.2012)"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </span>
                </Link>
              </div>
            </div>
          </div>

          {/* ---------- Right Icon ---------- */}
          <div className="col-lg-3 col-md-3">
            <div
              className="hero-icon wow zoomIn"
              data-wow-delay="700ms"
              data-wow-duration="800ms"
            >
              <img src={heroIcon} alt="Hero icon" />
            </div>
          </div>
        </div>

        {/* ---------- Features ---------- */}
        <div className="row mt-55">
          {HERO_FEATURES.map((item, index) => (
            <div className="col-lg-4 col-md-6 mt-30 d-flex" key={index}>
              <div
                className="xb-feature-item hero-feature-uniform w-100 wow fadeInUp"
                data-wow-delay={item.delay}
                data-wow-duration="600ms"
              >
                <div className="xb-item--inner xb-border">
                  <span className="xb-item--icon">
                    <img src={item.icon} alt="icon" />
                  </span>
                  <div className="xb-item--holder">
                    <h2 className="xb-item--title">{t(item.titleKey)}</h2>
                    <p className="xb-item--content">
                      {t(item.descKey)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
